
















import Vue from "vue";

export default Vue.extend({
  name: "ConfirmModal",
  props: {
    width: Number,
    title: String,
    body: String,
    show: Boolean,
    okText: String,
    cancelText: String,
    onOk: Function,
    onCancel: Function,
  },
  data() {
    return {};
  },
  computed: {
    _show(): any {
      return this.show;
    },
  },
  methods: {
    handleCancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.$emit("cancel");
    },
    handleOk() {
      if (this.onOk) {
        this.onOk();
      }
      this.$emit("ok");
    },
    cancel() {
      this._show = false;
    },
    ok() {
      this.$emit("ok");
    },
  },
});
